import React from 'react';
import DefaultProps from '../../commonTypes/defaultprops.types';
import Handler from '../../commonTypes/handler.types';

export interface ModalProps extends DefaultProps {
  customHeader?: React.ReactNode;
  headerTitle?: string;
  headerButton?: React.ReactNode;
  open?: boolean;
  fullScreenMobile?: boolean;
  disableClose?: boolean;
  height?: string;
  width?: string;
  overlay?: boolean;
  overlayOpacity?: number;
  overlayColor?: string;
  portalTarget?: HTMLElement;
  handlers?: Handler;
  position?: Position;
  animate?: boolean;
  animateFrom?: AnimateFrom;
  animationDuration?: number;
  draggable?: boolean;
  modalFooter?: React.ReactNode;
  closeButtonRef?: React.Ref<HTMLButtonElement>;
  closeButtonRight?: boolean;
  callHandlerOnDragClose?: boolean;
}

export interface Position {
  top?: number;
  bottom?: number;
  left?: number;
  right?: number;
}
export enum AnimateFrom {
  TOP = 'top',
  BOTTOM = 'bottom',
  LEFT = 'left',
  RIGHT = 'right',
}

export interface OverlayProps {
  open?: boolean;
  showOverlay?: boolean;
  color?: string;
  opacity?: number;
  onClickHandler: () => void;
  portalTarget?: HTMLElement;
  animationDuration?: number;
  animateOut?: boolean;
}

export interface HeaderProps extends DefaultProps {
  title?: string;
  button?: React.ReactNode;
  handlers: Handler;
  disableClose?: boolean;
  closeButtonRef?: React.Ref<HTMLButtonElement>;
  closeButtonRight?: boolean;
}
